import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'hot-text-highlight',
})

export default class HotTextHighlight extends Vue {

    // -----------------------------------------------------------------
    // Properties

    @Prop()
    private content: any;


    // --------------------------------------------------------------------
    // Hooks

    // --------------------------------------------------------------------
    // Methods

    private toFibText(text: any) {
        if (text) {
          const regExp = /(\[[^[\]]+])/gi;
          const replacer = (match: any, p1: any /*, p2, offset, text*/) => {
            return `<b>${match.substr(1, match.length - 2)}</b>`;
          };
          text = text.replace(regExp, replacer);
        }
        return text;
      }




}
